import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountRequest from "./counterpartyBankAccountRequest";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SubLedgerReportTransferPaymentRequest {
  @observable
  @Type(() => CounterpartyBankAccountRequest)
  bankAccount?: CounterpartyBankAccountRequest;

  @observable
  variableSymbol?: number;

  @observable
  constantSymbol?: number;

  @observable
  specificSymbol?: number;
}

export const SubLedgerReportTransferPaymentRequestValidationRules: EntityValidationRules<SubLedgerReportTransferPaymentRequest> =
  {
    bankAccount: {
      isLength: {
        min: 3,
        optional: true,
      },
    },
    variableSymbol: {
      isLength: {
        min: 3,
        optional: true,
      },
    },
    constantSymbol: {
      isLength: {
        min: 3,
        optional: true,
      },
    },
    specificSymbol: {
      isLength: {
        min: 3,
        optional: true,
      },
    },
  };
